import { render, staticRenderFns } from "./regGuide.vue?vue&type=template&id=235ecf51&scoped=true&"
import script from "./regGuide.vue?vue&type=script&lang=js&"
export * from "./regGuide.vue?vue&type=script&lang=js&"
import style0 from "./regGuide.vue?vue&type=style&index=0&id=235ecf51&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235ecf51",
  null
  
)

export default component.exports